import script from "./contactService.vue?vue&type=script&setup=true&lang=ts"
export * from "./contactService.vue?vue&type=script&setup=true&lang=ts"

import "./contactService.vue?vue&type=style&index=0&id=0adfc73b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0adfc73b"]])

export default __exports__